import { findExclusionGroup } from './exclusionGroups';
export const DUPLICATE_PURCHASE_ERROR = 'DUPLICATE_PURCHASE';
function normalizeOrderIds(orders) {
    if (!Array.isArray(orders))
        return [String(orders)];
    return orders.map((order) => String(typeof order === 'object' && order !== null ? order.id || order : order));
}
function assertNotPurchased(orderIds, purchasedOrderIds) {
    const purchased = new Set(purchasedOrderIds);
    const duplicates = orderIds.filter((id) => purchased.has(id));
    if (duplicates.length > 0) {
        const error = Object.assign(new Error('Upsell orders already purchased'), {
            code: DUPLICATE_PURCHASE_ERROR,
            duplicates,
        });
        throw error;
    }
}
function assertNoExclusiveGroupConflict(orderIds, purchasedOrderIds) {
    const purchased = new Set(purchasedOrderIds);
    for (const orderId of orderIds) {
        const group = findExclusionGroup(orderId);
        if (!group)
            continue;
        const conflicting = [...group.memberIds].filter((memberId) => purchased.has(memberId));
        if (conflicting.length > 0) {
            const error = Object.assign(new Error(`Exclusive group "${group.name}" already has a purchase`), {
                code: DUPLICATE_PURCHASE_ERROR,
                duplicates: conflicting,
            });
            throw error;
        }
    }
}
export { normalizeOrderIds, assertNotPurchased, assertNoExclusiveGroupConflict };
